import React from 'react';
import lottie from 'lottie-web';
import { defineElement } from 'lord-icon-element';
defineElement(lottie.loadAnimation);
const LoadingPage = () => {
    return (
        <div className='w-full h-screen flex-col flex items-center justify-center'>
            <div>
                <lord-icon
                    src="https://cdn.lordicon.com/qhgmphtg.json"
                    trigger="loop"
                    delay="1000"
                    colors="primary:#121331,secondary:#38bdf8"
                    style={{ width: 100, height: 100 }}>
                </lord-icon>
            </div>
            <div>
                <p className='text-[20px] md:text-[24px] text-black font-semibold'>Please Wait...</p>
            </div>
        </div>
    );
};

export default LoadingPage;